import { NavLink, Outlet } from "react-router-dom";
import { useAuth, atLeast } from "../lib/auth";

export default function Layout() {
  const { staff, logout } = useAuth();
  const isAdmin = atLeast(staff?.role, "super_admin");

  return (
    <div className="shell">
      <aside className="sidebar">
        <div className="brand">MSP Control</div>
        <nav>
          <NavLink to="/" end>
            Dashboard
          </NavLink>
          <NavLink to="/devices">Devices</NavLink>
          <NavLink to="/tickets">Tickets</NavLink>
          <NavLink to="/alerts">Alerts</NavLink>
          {isAdmin && <NavLink to="/admin">Admin</NavLink>}
        </nav>
        <div className="spacer" />
        <div className="muted" style={{ padding: "0 10px", fontSize: 12 }}>
          {staff?.name}
          <br />
          <span className="pill">{staff?.role}</span>
        </div>
        <button style={{ marginTop: 10 }} onClick={logout}>
          Sign out
        </button>
      </aside>
      <main className="main">
        <Outlet />
      </main>
    </div>
  );
}
